<div id="gallery-tabs" class="gallery-tabs">
  @if (presentationV3()) {
    <div class="collapse-button-wrapper-mobile">
      <button (click)="toggleGallery()">
        <span>
          {{ isGalleryOpen() ? 'Collapse Gallery' : 'Expand Gallery' }}
        </span>
        <mat-icon>
          {{ isGalleryOpen() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
        </mat-icon>
      </button>
    </div>
  }

  <div [ngClass]="{ 'gallery-tabs-header': true, 'gallery-closed': !isGalleryOpen() && !presentationV3 }">
    <div class="gallery-tabs-slider">
      @for (tab of galleryTabs(); let i = $index; track tab.name) {
        <div
          [ngClass]="{ 'gallery-tabs-tab': true, selected: tab.isSelected, 'gallery-tabs-margin': i }"
          title="{{ tab.name }}"
          (click)="changeTab(i)"
        >
          @if (tab.icon) {
            <mat-icon>{{ tab.icon }}</mat-icon>
          }
          <span class="text">{{ tab.name | truncate: 25 }}</span>
          @if (tab.isDeleteable) {
            <mat-icon class="close-icon" (click)="removeTab(i)">clear</mat-icon>
          }
        </div>
      }
    </div>
    @if (
      customTabs &&
      customTabs.length &&
      customTabs.length !== customGalleryTabs.length &&
      galleryService.hasBadgingQuestions
    ) {
      <div class="gallery-tabs-tab gap-0" (click)="openFilter()">
        <mat-icon>add</mat-icon>
        <div class="gallery-tabs-input" matAutocompleteOrigin #origin="matAutocompleteOrigin">
          <input
            #inputFilterOptions
            title="Filter Input"
            type="text"
            [formControl]="control"
            [matAutocomplete]="auto"
            [matAutocompleteConnectedTo]="origin"
            matAutocompletePosition="below"
            [ngClass]="{ 'input-active': addingFilter }"
            (blur)="closeInput()"
          />
          <mat-autocomplete #auto="matAutocomplete" class="custom-auto-complete-colors">
            @for (customTab of filteredTabs; track customTab.title) {
              @if (filterOptions(customTab)) {
                <mat-option [value]="customTab.title.toString()" (onSelectionChange)="createTab(customTab)">
                  {{ customTab.title | truncate: 25 }}
                </mat-option>
              }
            }
          </mat-autocomplete>
        </div>
        @if (addingFilter) {
          <mat-icon>arrow_drop_down</mat-icon>
        }
      </div>
    }
  </div>

  <div class="gallery-tabs-content" [ngClass]="{ 'content-closed': !isGalleryOpen() && !presentationV3 }">
    @if (presentationV3()) {
      <div class="pagination-wrapper">
        @if (showPagination) {
          <app-pagination
            [currentPage]="(galleryService.currentPage$ | async) || 1"
            [pageCount]="(galleryService.pageCount$ | async) || 1"
            [sideArrows]="true"
            [presentationV3]="true"
            [isMobile]="isMobile"
            [isGalleryOpen]="isGalleryOpen()"
            (nextPageSelected)="nextPage()"
            (prevPageSelected)="previousPage()"
          ></app-pagination>
        }
      </div>
      <div class="collapse-button-wrapper">
        <button (click)="toggleGallery()">
          <span>
            {{ isGalleryOpen() ? 'Collapse Gallery' : 'Expand Gallery' }}
          </span>
          <mat-icon>
            {{ isGalleryOpen() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
          </mat-icon>
        </button>
      </div>
    } @else {
      <!-- Pagination buttons -->
      @if (showPagination) {
        <app-pagination
          [currentPage]="(galleryService.currentPage$ | async) || 1"
          [pageCount]="(galleryService.pageCount$ | async) || 1"
          [sideArrows]="true"
          [isGalleryOpen]="isGalleryOpen()"
          (nextPageSelected)="nextPage()"
          (prevPageSelected)="previousPage()"
        ></app-pagination>
      }
    }

    @if (galleryGroups.length) {
      <div id="gallery-tabs-container" [ngStyle]="getContainerStyles()">
        @for (group of galleryGroups; let i = $index; track group.groupName) {
          <div>
            <div>
              @if (group.participants.length) {
                <div class="group-wrapper" [ngStyle]="getWrapperStyle(group.participants)">
                  @if (shouldShowLabel) {
                    <span
                      [matTooltip]="group.groupName.length ? group.groupName : null"
                      [matTooltipDisabled]="!group.groupName.length"
                      matTooltipPosition="above"
                    >
                      {{
                        (group.groupName.length ? group.groupName : 'No answer')
                          | truncate: getTruncateSize(group.participants.length)
                      }}
                    </span>
                  }
                  <div class="participant-group" [ngStyle]="getParticipantGroupStyle">
                    @for (participant of group.participants; track participant.userId) {
                      <div class="participant" [ngStyle]="getParticipantStyles()">
                        <app-video-bubble
                          [user]="participant"
                          [ringColor]="getParticipantRingColor(participant.userId)"
                          [size]="videoSize"
                          [visualIndicators]="newVisualIndicators"
                          [isGallery]="true"
                          [@GalleryAnimation]="checkGalleryState(participant)"
                          [showAnimation]="isUserSpeaking(participant)"
                        ></app-video-bubble>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (isFavoritesEmpty) {
          <div class="empty-favorites-tab" [ngStyle]="{ marginTop: presentationV3() && '8px' }">
            Your favorited <mat-icon> star </mat-icon> people will populate here
          </div>
        }
      </div>
    }
  </div>
</div>
